import React, { PureComponent } from 'react'
import ContextButton from 'aria-viewer/tour/components/buttons/contextButton'
import { showVideoQualityContextMenu } from 'aria-viewer/contextmenu/contextMenuActions'
import { connect } from 'react-redux'
import { VIDEO_QUALITY_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

class VideoQualityButton extends PureComponent {
    constructor(props) {
        super(props)

        this.handleOnClick = this.handleOnClick.bind(this)
    }

    handleOnClick(e) {
        e && e.stopPropagation && e.stopPropagation()
        e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
        e && e.preventDefault && e.preventDefault()

        const { onClick, showVideoQualityContextMenu } = this.props
        onClick && onClick(e)
        showVideoQualityContextMenu(e)
    }

    render() {
        const { offsetY } = this.props

        return (
            <ContextButton
                tabIndex={VIDEO_QUALITY_BUTTON_INDEX}
                offsetX={10}
                offsetY={offsetY}
                onClick={this.handleOnClick}
                style={this.props.style}
                icon="videoSetting"
                theme="video_button"
            />
        )
    }
}

export default connect(
    null,
    {
        showVideoQualityContextMenu,
    }
)(VideoQualityButton)
